import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterColumnItemBlockConfig } from '@front-platform/content-builder';
import { bigFooterColumnItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface BigFooterColumnItemBlockRuntimeConfig {}

export type BigFooterColumnItemBlockConfigInput = Partial<
  Omit<BigFooterColumnItemBlockConfig, keyof BigFooterColumnItemBlockRuntimeConfig> &
    BigFooterColumnItemBlockRuntimeConfig
>;
export type BigFooterColumnItemBlockResolvedConfig = Omit<
  BigFooterColumnItemBlockConfig,
  keyof BigFooterColumnItemBlockRuntimeConfig
> &
  Partial<BigFooterColumnItemBlockRuntimeConfig>;
export interface BigFooterColumnItemBlockContract extends ConfigComponentContract<
  BigFooterColumnItemBlockConfigInput,
  BigFooterColumnItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-column-item-block',
  templateUrl: './big-footer-column-item-block.component.html',
  standalone: false,
})
export class BigFooterColumnItemBlockComponent implements BigFooterColumnItemBlockContract {
  readonly config = input<BigFooterColumnItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterColumnItemBlockConfig,
    BigFooterColumnItemBlockRuntimeConfig
  >(bigFooterColumnItemBlockResolveConfig, () => ({ config: this.config() }));
  get name(): string {
    return this.resolvedConfig()['name'] as unknown as string;
  }
  get link(): string {
    return this.resolvedConfig()['link'] as unknown as string;
  }
  get openInNewTab(): boolean | undefined {
    return this.resolvedConfig()['open_in_new_tab'] as unknown as boolean | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterColumnItemBlockComponent, {
  'keyAliases': {},
});
